<template>
  <div class="ProductDetail__container">
    <section class="ProductDetail Section">
      <div class="ProductDetail__header">

        <p class="ProductDetail__free" v-if="hasFreeProducts">
          {{ offer.products_number }} {{ "achetée" | pluralize(offer.products_number) }} = <span>{{ offer.products_number_free }} {{ "offerte" | pluralize(offer.products_number_free) }}*</span>
        </p>

        <p class="ProductDetail__free" v-if="hasSpecialPrice">
          {{ offer.offer_text ? offer.offer_text : "Offre spéciale" }}
        </p>
        <div class="ProductDetail__side-container">
          <img class="ProductDetail__picture" :src="largePictureURL" alt="Bouteille" />
          <div class="ProductDetail__infos">
            <h1 class="ProductDetail__title">
              {{ name }} {{ year }}<br />
              {{ additional_name }}
            </h1>
            <h2 class="ProductDetail__subtitle">
              <span v-if="family">{{ family }}</span>
              <span v-if="family && displayColor"> | </span>
              <span v-if="displayColor">{{ localeColor }}</span>
              <template v-if="capacity">
                <span v-if="capacity === '75cl'"><br />{{ capacity }}</span>
                <span v-else><br /><span class="ProductDetail__extra-capacity"> {{ capacityLabel }}</span></span>
              </template>
            </h2>

            <div class="ProductDetail__meta">
              <IconBase class="ProductDetail__bio" v-if="bio" iconName="AB" width="28" height="28"><IconAB /></IconBase>
              <IconBase v-if="gcc" iconName="gcc"><IconGcc /></IconBase>
              <ProductLabels :labels="labels" />

              <div class="ProductDetail__best-price-wrapper">
                <label class="ProductDetail__from" v-if="!hasSpecialPrice">À partir de&nbsp;:</label>
                <div v-if="hidden_price" class="ProductDetail__best-price">N.C.</div>
                <Price v-else :price="bestPrice" class="ProductDetail__best-price" />
              </div>
            </div>

            <aside class="ProductDetail__prices" v-if="!hasSpecialPrice && formatedPricePerQuantity.length > 1 && !hidden_price">
              <span class="ProductDetail__price-label">Prix par Qté:</span>
              <span class="ProductDetail__price" v-for="(pricing, index) in formatedPricePerQuantity" :key="index">
                <span class="ProductDetail__price-value">{{ pricing.price }}<small>€</small></span>
                <span v-if="index > 0" class="ProductDetail__price-step">{{ "&ge;" + pricing.quantity }}</span>
                <span v-else class="ProductDetail__price-step">&lt;{{ formatedPricePerQuantity[index + 1].quantity }}</span>
              </span>
            </aside>

            <div v-if="displayLogistic" class="ProductDetail__logistic">{{ logistic_sender }}</div>

            <div v-if="isObsolete" class="ProductDetail__obsolete">
              <div class="ProductDetail__obsolete-text">
                Cette offre n’est plus disponible, contactez votre captain pour en savoir plus.
              </div>
              <router-link class="Button Button--primary" :to="{name: 'Agent'}">Contacter {{ agent.firstname }}</router-link>
            </div>
            <div v-else-if="hidden_price" class="ProductDetail__hidden-price">
              <div class="ProductDetail__hidden-price-text">Contactez votre captain pour en savoir plus</div>
              <router-link class="Button Button--primary" :to="{name: 'Agent'}">Contacter {{ agent.firstname }}</router-link>
            </div>
            <div class="ProductDetail__order" v-else>
              <Quantity class="ProductDetail__quantity" v-model="quantity" :step="orderStep" />
              <Button type="button" :loading="loading" @click.native="addToCart()" class="Button--primary">
                Ajouter à ma commande&nbsp;
                <IconBase iconName="cart"><IconCart /></IconBase>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <button v-if="descriptions.length > 0" class="ProductDetail__description-btn" type="button" @click="isDescShown = !isDescShown"><p>Afficher plus d’informations</p><img class="chevron" :style="chevronStyle" src="@/assets/images/chevron-down.svg" /></button>
        <transition name="fade">
          <div v-if="!isMobile || isDescShown">
            <div v-for="(description, idx) in descriptions" :key="idx">
              <h4 v-if="description.label" class="ProductDetail__label">{{ description.label }}</h4>
              <h4 v-else class="ProductDetail__label">Description</h4>
              <p class="ProductDetail__description">{{ description.text }}</p>
              <div class="ProductDetail__description-dash" v-if="idx !== descriptions.length - 1"></div>
            </div>
          </div>
        </transition>

        <div class="ProductDetail__free-conditions" v-if="offer && offer.conditions">* {{ offer.conditions }}</div>
      </div>

    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import productMixin from "../mixins/productMixin";
import notificationService from "../services/notification";
import isMobile from "../utils/isMobile";
import Quantity from "./Quantity";
import Button from "./Button";
import ProductLabels from "./ProductLabels";
import IconGcc from "./icons/IconGcc";
import IconAB from "./icons/IconAB";
import IconCart from "./icons/IconCart";

export default {
  name: "ProductDetail",
  mixins: [productMixin],
  data() {
    return {
      quantity: 0,
      isDescShown: false
    };
  },
  computed: {
    ...mapGetters("auth", ["agent"]),
    isMobile,
    chevronStyle() {
      return this.isDescShown ? { transform: "rotate(-90deg)" } : { transform: "rotate(0deg)" };
    }
  },
  methods: {
    addToCart() {
      this.loading = true;

      this.$store.dispatch("cart/addToCart", {
        product_id: this.id,
        quantity: this.quantity
      })
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "Cart" });
        })
        .catch(err => {
          this.loading = false;
          notificationService.error(err.message, err.errors);
        });
    }

  },
  created() {
    this.quantity = this.orderStep;
  },
  components: {
    IconGcc,
    IconAB,
    IconCart,
    Quantity,
    ProductLabels,
    Button
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.ProductDetail__container {
  margin-top: $global-margin;
  background-color: #fff;
}

.ProductDetail {
  @media (min-width: 900px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: flex-start;
    justify-content: stretch;
    grid-gap: $global-margin;
  }

  &__header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: $global-margin;
    min-height: 42vh;
  }

  &__free {
    width: 100%;
    padding: 0.875em;
    margin: 0 auto auto;
    background: $color-secondary;
    color: #fff;
    text-align: center;
    text-transform: uppercase;

    @media (min-width: 900px) {
      font-size: 1.125rem;
    }

    span {
      font-weight: 700;
    }
  }

  &__side-container {
    display: flex;
    align-items: center;
  }

  @media (max-width: 900px) {
    &__side-container {
      flex-direction: column;
    }

    &__infos {
      margin: 0 2*$global-margin;
    }
  }

  &__picture {
    height: 18em;
    width: 8em;
    object-fit: contain;
    margin: $global-margin;
  }

  &__bio {
    margin-right: 0.225em;
  }

  &__title {
    text-transform: uppercase;
    font-size: 1.125rem;
    font-weight: 900;
    margin-bottom: 0;

    img,
    svg {
      margin-left: 5px;
    }
  }

  &__subtitle {
    margin-top: 0;
    font-size: 0.875rem;
    font-weight: 400;
    color: $color-grey;
  }

  &__from {
    font-size: 0.75rem;
    font-weight: 400;
  }

  &__best-price-wrapper {
    margin-left: auto;
  }

  &__best-price {
    margin: 0 0 $global-margin;
    font-size: 1.625rem;
    font-weight: 900;
    color: $color-secondary;

    sup {
      font-size: 0.5em;
    }
  }

  &__prices {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
  }

  &__price-label {
    font-size: 0.625rem;
    font-weight: 700;
  }

  &__price-value {
    display: block;
    font-weight: 900;

    sup {
      font-size: 0.3em;
    }
  }

  &__price-step {
    color: $color-grey;
    font-size: 0.875rem;
  }

  &__meta {
    display: flex;
    align-items: flex-start;
    // justify-content: space-between;
  }

  &__free-conditions {
    font-size: 0.625rem;
  }

  &__label {
    margin: $global-margin 0 0 0;
    text-transform: uppercase;
  }

  &__description {
    margin-top: 0;
    font-size: 0.75rem;
    line-height: 1.2;
  }

  &__description-dash {
    width: 20px;
    height: 6px;
    background-color: $color-primary;
    margin-top: $global-margin;
  }

  &__description-btn {
    display: none;
  }

  @media (max-width: 900px) {
    &__description-btn {
      margin: 0 auto;
      display: flex;
      align-items: center;
      border: none;
      background-color: transparent;
      cursor: pointer;

      .chevron {
        transition: transform 0.5s;
      }
    }
  }

  &__obsolete {
    text-align: center;
    font-size: 1rem;
    line-height: 1.2;
    margin-bottom: $global-margin;
    color: $color-grey;

    &-text {
      margin-bottom: $global-margin;
    }
  }

  &__hidden-price {
    text-align: center;
    font-size: 1rem;
    line-height: 1.2;
    margin-top: $global-margin * 2;
    color: $color-grey;

    &-text {
      margin-bottom: $global-margin;
    }
  }

  &__quantity {
    margin: 2*$global-margin 0 $global-margin;
    color: $color-primary;
    font-size: 1.3125rem;
  }

  &__order {
    text-align: center;

    .Button {
      border-radius: 4px;
      font-size: 0.875rem;
      padding: 0.625em 0.875em;
      text-transform: uppercase;
      margin: 0 auto $global-margin;
    }
  }

  &__logistic {
    text-align: center;
    border-top: 1px solid $color-black;
    font-size: 0.6em;
    text-transform: uppercase;
    padding-top: 10px;
    font-weight: 700;
    margin-top: 10px;
  }

  &__extra-capacity {
    border-radius: $global-radius / 2;
    font-size: 0.675rem;
    font-weight: 700;
    margin-top: 4px;
    padding: 0.2rem;
    display: inline-block;
    background-color: $color-danger;
    color: #fff;
  }
}
</style>
